import { render, staticRenderFns } from "./FilesPreview.vue?vue&type=template&id=27a64b38"
import script from "./FilesPreview.vue?vue&type=script&lang=js"
export * from "./FilesPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports